import { render, staticRenderFns } from "./livelist.vue?vue&type=template&id=623c1cc5&"
import script from "./livelist.vue?vue&type=script&lang=js&"
export * from "./livelist.vue?vue&type=script&lang=js&"
import style0 from "./livelist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports